/**
 * Returns a same-origin relative path suitable for post-login redirects.
 * Rejects protocol-relative and absolute URLs.
 */
export function getSafeRedirectPath(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null;
  return trimmed;
}
